import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import Grid from '@material-ui/core/Grid';
import cn from 'classnames';
import get from 'lodash/get';
import { useTranslation } from '../../src/i18n';
import { boxShadows, colors } from '../../constants/styleConstants';
import { ARTIST_TAB_VALUES, TP } from '../../constants/consts';

const useStyles = makeStyles(theme => ({
  review: {
    marginBottom: 10,
    borderRadius: 5,
    boxShadow: boxShadows.card,
  },
  reviewBody: {
    fontSize: 15,
    fontWeight: 300,
    padding: theme.spacing(2),
  },
  smallReviewBody: {
    padding: 0,
  },
  reviewer: {
    fontSize: 15,
    fontWeight: 'bold',
    color: colors.grey1,
    letterSpacing: 'normal',
  },
  quotes: {
    width: 34,
  },
  viewAllLink: {
    borderTop: '1px solid rgba(0, 0, 0, 0.2)',
    display: 'flex',
    justifyContent: 'center',
    paddingTop: 5,
  },
  content: {
    marginBottom: 16,
  },
  root: {
    display: 'flex',
    alignItems: 'center',
    borderBottom: `solid 1px ${colors.contentDivider}`,
    '&:last-child': {
      borderBottom: 'none',
    },
    wordWrap: 'break-word',
  },
  icon: {
    display: 'flex',
    justifyContent: 'flex-end',
    color: colors.grey1,
  },
  wrapper: {
    wordWrap: 'break-word',
  },
  footer: {
    padding: 15,
    display: 'flex',
    justifyContent: 'center',
    fontSize: 15,
    fontWeight: 'bold',
    color: colors.blueChip,
    '& span': {
      cursor: 'pointer',
    },
  },
}));

const ReviewsCard = ({ className, reviews, isSmall, goToTab }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  if (!reviews || reviews.length === 0) return null;

  return (
    <div className={cn(classes.reviewsContainer, className)}>
      {reviews.map((review, key) => {
        const reviewUrl = get(review, 'reviewUrl');

        return (
          <Grid item md={12} xs={12} className={classes.root} key={`reviewItems-${key}`}>
            <Grid item xs={11} md={11} key={review?.id}>
              <div className={cn(classes.reviewBody)}>
                <div className={classes.content}>
                  {get(review, 'content', '')}
                  {reviewUrl && (
                    <div>
                      ...
                      <a href={reviewUrl} target="_blank">
                        {t(`${TP}.FULL_REVIEW`)}
                      </a>
                    </div>
                  )}
                </div>
                <div className={classes.reviewer}>{get(review, 'signature', '')}</div>
                <div className={classes.wrapper}>
                  <a href={reviewUrl} target="_blank">
                    {get(review, 'mediaName', '')}
                  </a>
                </div>
              </div>
            </Grid>
            {reviewUrl && (
              <Grid item xs={1} md={1}>
                <a className={classes.icon} href={reviewUrl} target="_blank">
                  <ChevronRightIcon />
                </a>
              </Grid>
            )}
          </Grid>
        );
      })}
      {isSmall && (
        <div className={classes.footer}>
          <span onClick={() => goToTab(ARTIST_TAB_VALUES.REVIEWS)}> {t(`${TP}.MORE_REVIEWS`)}</span>
        </div>
      )}
    </div>
  );
};

ReviewsCard.propTypes = {
  className: PropTypes.string,
  reviews: PropTypes.array,
  isSmall: PropTypes.bool,
};

export default ReviewsCard;
